import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { User } from 'src/app/models/users.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileCompletionGuard implements CanActivate {
  constructor(
    private auth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const authUser = await this.auth.currentUser;
      if (!authUser) {
        // Let AuthService handle authentication
        return true;
      }

      const userDoc = await this.afs.doc<User>(`users/${authUser.uid}`).get().toPromise();
      const user = userDoc?.data();

      if (user?.profileIncomplete === true) {
        this.router.navigate(['/auth/profile-complete']);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking profile completion:', error);
      return true; // Allow access on error to prevent blocking
    }
  }
}
